
import { vertex_1 } from "../shaders/shader";
import { FboBase } from "./FboBase";

export class Divergence extends FboBase {
    constructor(props) {
        super({
            common: props.common,
            material: {
                vertexShader: vertex_1,
                fragmentShader: /*glsl */`precision highp float;
                    uniform sampler2D velocity;
                    uniform float dt;
                    uniform vec2 px;
                    varying vec2 uv;

                    void main(){
                        float x0 = texture2D(velocity, uv-vec2(px.x, 0)).x;
                        float x1 = texture2D(velocity, uv+vec2(px.x, 0)).x;
                        float y0 = texture2D(velocity, uv-vec2(0, px.y)).y;
                        float y1 = texture2D(velocity, uv+vec2(0, px.y)).y;
                        float divergence = (x1-x0 + y1-y0) / 2.0;

                        gl_FragColor = vec4(divergence / dt);
                    }`,
                uniforms: {
                    boundarySpace: {
                        value: props.boundarySpace
                    },
                    velocity: {
                        value: props.src.texture
                    },
                    px: {
                        value: props.cellScale
                    },
                    dt: {
                        value: props.dt
                    }
                }
            },
            output: props.dst
        });
        this.init();
    }
    update({vel: e}) {
        this.uniforms.velocity.value = e.texture;
        super.update();
    }
}